import styled from "styled-components";
import { motion } from "framer-motion";

export const TurnosDisponiblesContainer = styled.div`
  display: flex;
`;

export const BodyTurnosDisponibles = styled(motion.div)`
  height: 82vh;
  height: 82dvh;
  margin-top: 10px;
  padding: 0px;
  overflow-y: scroll;
  /* Oculta barra de scroll pero permite desplazamiento: solo tablet/desktop */
  @media (min-width: 768px) {
    -ms-overflow-style: none; /* IE y Edge */
    scrollbar-width: none; /* Firefox */
  }
  @media (min-width: 768px) {
    &::-webkit-scrollbar {
      /* Chrome, Safari y Opera */
      display: none;
    }
  }
  @media (max-width: 600px) {
    height: 79vh;
    height: 79dvh;
  }
`;

export const FiltrosContainer = styled.div`
  background: var(--color-primary-gradient-y);
  box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.14);
  height: 93vh;
  height: 93dvh;
  overflow-y: scroll;
  width: 15%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* width */
  ::-webkit-scrollbar {
    width: 2px;
    background: var(--color-primary) !important;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--color-primary) !important;
    border-radius: 10px;
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const TurnosDisponiblesBox = styled.div`
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  padding-bottom: 20px;
`;

export const InformacionTurnosBox = styled.div`
  width: 85%;
  display: flex;
  flex-direction: column;
  @media (max-width: 1024px) {
    width: 100%;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  /* gap: 30px; */
  align-items: center;
  justify-content: space-evenly;
  padding: ${({ $mobile }) => ($mobile ? "14px 0" : "20px")};
  border-bottom: ${({ $mobile }) =>
    $mobile ? "1px solid var(--color-grey77)" : ""};
`;

export const InfoFiltrosBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 20px 10px 20px;
  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14);
`;

export const FiltrosAplicadosBox = styled.div`
  display: ${({ $showFiltros }) => ($showFiltros ? "flex" : "none")};
  flex-wrap: wrap;
  gap: 10px;
  .txtFiltros {
    width: 100%;
    text-align: center;
  }
`;

export const FiltroEtiqueta = styled.div`
  height: 26px;
  width: max-content;
  padding-left: 8px;
  padding-right: 6px;
  padding-top: 8px;
  padding-bottom: 8px;
  background: var(--color-latex30);
  border-radius: 20px;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  gap: 8px;
  .cruzBox {
    position: relative;
    background-color: transparent;
    transition: background-color 0.2s ease;
    border-radius: 50%;
    padding: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .cruzBox:hover {
    background-color: rgba(
      255,
      255,
      255,
      0.5
    ); /* Fondo blanco con 50% de opacidad */
  }
`;

export const EspecialidadBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .espTxt {
    width: 36vh;
  }
  .especialidad-container {
    width: max-content;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const FlechaContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-right: 8px;
  transform: ${(props) => props.$rotate && `rotate(180deg)`};
  transition: 0.2s ease;
`;

export const EtiquetaContainer = styled.div`
  height: 42px;
  width: max-content;
  padding-left: 14px;
  padding-right: 18px;
  padding-top: 10px;
  padding-bottom: 9px;
  background: var(--color-latex30);
  border-radius: 20px;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PacienteBox = styled.div``;

export const FechaBusqBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MasTurnosBtn = styled.button`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  background-color: var(--color-white);
  border: 2px solid var(--color-latex30);
  padding: 10px;
  border-radius: 8px;
  color: var(--color-latex30);
  cursor: pointer;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`;
export const MasTurnosBox = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  justify-content: center;
`;
export const FiltroBox = styled(MasTurnosBox)``;

export const LineSep = styled.div`
  position: relative; /* Necesario para posicionar los pseudo-elementos */
  width: 4px;
  &::before {
    content: ""; /* Esto asegura que el pseudo-elemento se renderice */
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 28px; /* Grosor de la línea */
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0),
      var(--color-grey77),
      rgba(0, 0, 0, 0)
    ); /* Gradiente difuminado */
    transform: translateY(-50%); /* Centra el pseudo-elemento verticalmente */
  }
`;
